import { render } from "./BoardArticlesEventWrite.vue?vue&type=template&id=85548344"
import script from "./BoardArticlesEventWrite.vue?vue&type=script&lang=js"
export * from "./BoardArticlesEventWrite.vue?vue&type=script&lang=js"

import "./BoardArticlesEventWrite.vue?vue&type=style&index=0&id=85548344&lang=css"

import exportComponent from "D:\\childu_lms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__